var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../classes/runtime/Runtime';
export class QuestionTypeLegacy {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get questionTypeStore() {
        return this.parent;
    }
    get question() {
        return this.questionTypeStore.question;
    }
    get questionPart() {
        return this.question.questionPart;
    }
    get legacyImagePlaces() {
        return [];
    }
    /*
    get additionalLegacyImages(): LegacyImage[] {
      return [];
    }
  */
    legacyImages_stored = [];
    get legacyImages() {
        return undefined;
        /* const legacyImages = this.legacyImagePlaces
          .map(([place, aspect]) => {
            if (
              !aspect.local.has.image ||
              !aspect.local.ensuredLowestTraitOf.image.essence.local.has.imageFile ||
              !aspect.local.ensuredLowestTraitOf.image.essence.local.ensuredLowestTraitOf.imageFile.value
            ) {
              return undefined;
            }
    
            const legacyImage = aspect.local.ensuredLowestTraitOf.image.essence.local.ensuredLowestTraitOf.imageFile.value.imgLegacy.toLegacy(
              place,
            );
    
            return legacyImage;
          })
          .filter(x => !!x);
        // must be alphabetically ascending
        return legacyImages.concat(this.additionalLegacyImages).sort(sortByFunc((i: LegacyImage) => i.place)) as LegacyImage[]; */
    }
    set legacyImages(legacyImageRows) {
        this.legacyImages_stored = legacyImageRows;
        const legacyRows = legacyImageRows.map(row => ({ ...row }));
        const matchedRows = [];
        this.legacyImagePlaces.forEach(([place, aspect]) => {
            const [legacyImageRow] = legacyRows.filter(row => row.place === place);
            if (legacyImageRow) {
                this.setLegacyImageToAspect(legacyImageRow, aspect);
                matchedRows.push(legacyImageRow);
            }
            else if (runtime.runtimePermissions.hasEditFunctionality &&
                aspect.local.has.image &&
                this.question.context.app.edit &&
                !this.question.context.app.solidEdit.isCopyModeActive) {
                //  aspect.local.removeAll.image(); //   CURRENTLY: SOFT MODE
            }
        });
        this.realizeUnmatchedLegacyImages(legacyRows.filter(x => !matchedRows.includes(x)));
    }
    setLegacyImageToAspect(legacyImageRow, aspect) {
        const img = aspect.local.ensuredLowestTraitOf.image.essence.local.ensuredLowestTraitOf.imageFile.value;
        if (legacyImageRow && img && img.legacyId === legacyImageRow.id)
            return;
        img.imgLegacy.fromLegacy(legacyImageRow);
    }
    get legacyCommentPlaces() {
        return [];
    }
    /*
    get additionalLegacyComments(): LegacyComment[] {
      return [];
    }
  */
    get legacyComments() {
        return undefined;
        /*  const legacyComments = this.legacyCommentPlaces
          .map(([place, commentAspect]) => {
            const legacyComment = commentAspect.aspectRole.aspectRoleComment.toLegacy;
            if (legacyComment) legacyComment.place = place;
            return legacyComment;
          })
          .filter(x => !!x);
        // must be alphabetically ascending
        return legacyComments.concat(this.additionalLegacyComments).sort(sortByFunc((l: LegacyComment) => l.place)) as LegacyComment[]; */
    }
    set legacyComments(legacyCommentRows) {
        const legacyRows = legacyCommentRows.map(row => ({ ...row }));
        const matchedRows = [];
        /*
        legacyRows.forEach(legacyCommentRow => {
          if (legacyCommentRow.question_id !== this.question.id) {
            legacyCommentRow.id = undefined;
            legacyCommentRow.question_id = this.question.id;
          }
        });*/
        this.legacyCommentPlaces.forEach(([place, commentAspect]) => {
            const legacyCommentRow = legacyRows.find(row => row.place === place);
            if (legacyCommentRow) {
                this.setLegacyCommentToAspect(legacyCommentRow, commentAspect);
                matchedRows.push(legacyCommentRow);
            }
            else {
                commentAspect.persistentAspect.traits.clear();
            }
        });
        this.realizeUnmatchedLegacyComments(legacyRows.filter(x => !matchedRows.includes(x)));
    }
    setLegacyCommentToAspect(legacyCommentRow, aspect) {
        aspect.aspectRole.aspectRoleComment.fromLegacy(legacyCommentRow);
    }
    realizeUnmatchedLegacyComments(legacyCommentRows) { }
    realizeUnmatchedLegacyImages(legacyCommentImages) { }
}
__decorate([
    computed
], QuestionTypeLegacy.prototype, "legacyImagePlaces", null);
__decorate([
    computed
], QuestionTypeLegacy.prototype, "legacyCommentPlaces", null);
__decorate([
    computed
], QuestionTypeLegacy.prototype, "legacyComments", null);
